// PLAN-cockpit-v2-iter1 Phase 3-C (2026-05-11):
// Detail Panel を開くたびに localStorage に push、Home Lens で再アクセス導線にする
import { useCallback, useEffect, useState } from 'react'

const STORAGE_KEY = 'cockpit_v2.recently_opened'
const EVENT_NAME = 'recently_opened_change'
const MAX_ITEMS = 20

export interface RecentlyOpenedItem {
  id: string
  itemType: 'entry' | 'article'
  title: string
  opened_at: string
}

function load(): RecentlyOpenedItem[] {
  try {
    const v = window.localStorage.getItem(STORAGE_KEY)
    if (!v) return []
    const arr = JSON.parse(v)
    return Array.isArray(arr)
      ? arr.filter((x): x is RecentlyOpenedItem =>
          !!x && typeof x === 'object'
            && typeof (x as { id?: unknown }).id === 'string'
            && typeof (x as { title?: unknown }).title === 'string'
        )
      : []
  } catch { return [] }
}

function persist(items: RecentlyOpenedItem[]) {
  try { window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items)) } catch { /* ignore */ }
}

export function pushRecentlyOpened(item: Omit<RecentlyOpenedItem, 'opened_at'>) {
  if (!item.id || !item.title) return
  const cur = load()
  const filtered = cur.filter(x => x.id !== item.id)
  const next: RecentlyOpenedItem[] = [{ ...item, opened_at: new Date().toISOString() }, ...filtered].slice(0, MAX_ITEMS)
  persist(next)
  window.dispatchEvent(new CustomEvent(EVENT_NAME))
}

export function useRecentlyOpened(limit = 5) {
  const [items, setItems] = useState<RecentlyOpenedItem[]>(load)

  useEffect(() => {
    const handler = () => setItems(load())
    window.addEventListener(EVENT_NAME, handler)
    return () => window.removeEventListener(EVENT_NAME, handler)
  }, [])

  const clear = useCallback(() => {
    persist([])
    setItems([])
    window.dispatchEvent(new CustomEvent(EVENT_NAME))
  }, [])

  return { items: items.slice(0, limit), clear }
}
